import React from 'react';
import classes from "./styles/secondSection.module.css";
import img1 from "../../assets/secondSec/img1.png";
import certificateImg from "../../assets/secondSec/medal.png";
import { useNavigate } from 'react-router-dom';

const SecondSection = () => {
  const navigate = useNavigate();
//   const sectionRef = useRef(null);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const targetElement = sectionRef.current;

//     const observer = new IntersectionObserver(
//         ([entry]) => {
//             if (entry.isIntersecting) {
//                 setIsVisible(true);
//             }
//         },
//         { threshold: 0.5 }
//     );

//     if (targetElement) {
//         observer.observe(targetElement);
//     }

//     return () => {
//         if (targetElement) {
//             observer.disconnect();
//         }
//     };
// }, []);


  return (
    <div className={classes.mainCon}>
    <div className={classes.container} >
      <div className={classes.innerCon}></div>
    </div>
      <img src={img1} alt='coach' className={`${classes.coachImg}`}/>
      <h2 className={classes.title}>Know Your Coach</h2>
      <div className={classes.meetCoachCon}>
            <h3><img src={certificateImg} alt="certificate" /><span><b>Susmita Roy</b> Blending Science, Nutrition, and Farming to Build Rooted Health</span></h3>
            <p>Susmita Roy is not your typical fitness coach or nutritionist. She’s a functional fitness expert who designs real, sustainable fitness solutions <b>for people juggling with work family and personal goal</b>. As a mother of a toddler and the co-founder of three businesses, Susmita understands that life isn’t a 12-week or 24-week transformation challenge—it’s a lifelong journey.</p>
            <button className={`${classes.knowBtn} button`} onClick={() => navigate("/know-your-coach")}>Know More</button>
      </div>
    </div>
  )
}

export default SecondSection;
